/**
 * 需在使用页面导入使用
 * import elList from "@/utils/elList"
 * mixins: [elList]
 * 需要在当前使用页面注入请求路径moduleUrl以及查询列表路径
 * moduleUrl:列表查询、新增、删除、编辑接口前缀
 * listUrl:列表查询接口后缀不是'/list'时,需传入listUrl
 * moduleUrl: "/scit-ig/system/role", listUrl: "/scit-ig/system/role/list"
 * queryProps等组件配置使用v-bind绑定
 * <el-form v-bind="queryProps">
 * 多选需在组件声明tableRef调用表格回显事件
 * 可传入参数自定义tableData及queryParams名称，使用方法如下：
 * const mixin = new MyMixin({list: "listName", query: "queryName"});
 */

import base from "../base";
import utils from "../utils";

export function CustomList(params) {
  let customData = Object.assign(
    {
      list: "tableData",
      query: "queryParams",
      lazyLoad: false,
      tableRef: "multipleTable",
      delParams: "",
    },
    params
  );
  return {
    data() {
      return {
        isInit: true, // 是否默认请求列表数据
        queryParams: {}, // 请求列表参数
        tableData: [], // 列表数据源
        listLoading: false, // 列表加载动画
        delLoading: false, // 批量删除加载动画
        paginations: {
          pageNum: 1, // 页数
          pageSize: 20, // 页码
          total: 0, // 总数
        },
        currentRow: null, // 表格当前选中行
        selectUuids: [], // 列表多选操作id集合
        selectList: [], // 列表选中的集合
        otherList: [],
        btnList: [], // 按钮列表
        queryProps: {
          // 查询表单基础设置
          inline: true,
          size: "small",
        },
        //   "label-width": "auto",
      };
    },
    computed: {
      isHasBtn() {
        let btnPermission = this.btnList.filter((item) => {
          if (item && item.permission) {
            return item.permission;
          }
        });
        return utils.isHasBtn(btnPermission);
      },
      queryBtn() {
        return "查询";
      },
      resetBtn() {
        return "重置";
      },
    },
    watch: {
      isHasBtn(val) {
        if (!val && this.btnList.length > 0) this.btnList = [];
      },
    },
    activated() {
      if (this.isInit) this.initList();
    },
    created() {
      if (!this.$route.meta || !this.$route.meta.keepAlive) {
        if (this.isInit) this.initList();
      }
    },
    methods: {
      handleClick(click, row) {
        this[click](row);
      },
      // 初始化请求列表
      initList() {
        if (this.initListExtend) this.initListExtend();
        if (this.listUrl || this.moduleUrl) {
          this.getList();
        }
      },
      // 获取分页列表数据,paginations.pageSize-1,pageNum:1时获取全部数据
      getList() {
        this[customData.list] = [];
        this.listLoading = true;
        if (!this.listUrl) {
          this.listUrl = this.moduleUrl ? this.moduleUrl + "/list" : "";
        }
        let queryData = {
          ...this[customData.query],
          ...this.paginations,
        };
        utils.formTrim(queryData);
        base
          .list(this.listUrl, queryData)
          .then((res) => {
            if (res.code === "00000") {
              this[customData.list] =
                res.data && res.data.records ? res.data.records : [];
              this.paginations.total = res.data ? res.data.total : 0;
              this.formatterList(this[customData.list]);
              if (this.getListExtend) this.getListExtend();
              if (customData.lazyLoad) {
                this.setChildFlag(this[customData.list]);
              }
              this.listLoading = false;
              this.getBtnList();
              if (this.selectUuids.length === 0) return;
              // 筛选选中列表数据,支持跨页选中
              const uuids = this[customData.list].map((item) => item.uuid);
              this.otherList = this.selectList.filter(
                (val) => !uuids.includes(val.uuid)
              );
              let selectUuids = JSON.parse(JSON.stringify(this.selectUuids));
              this.$nextTick(() => {
                if (this.$refs[customData.tableRef]) {
                  utils.setTableCheck(
                    this[customData.list],
                    selectUuids,
                    this.$refs[customData.tableRef]
                  );
                }
              });
            } else {
              this.listLoading = false;
            }
          })
          .catch(() => {
            this.listLoading = false;
          });
      },
      /**懒加载数据 */
      lazyLoad(tree, treeNode, resolve) {
        let data = { ...this.queryParams, ...{ parentUuid: tree.uuid } };
        utils.formTrim(data);
        let paginations = {
          pageSize: -1,
          pageNum: 1,
        };
        if (!this.listUrl) {
          this.listUrl = this.moduleUrl ? this.moduleUrl + "/list" : "";
        }
        base
          .list(this.listUrl, Object.assign(data, paginations))
          .then((res) => {
            if (res.code === "00000") {
              if (res.data && res.data.records) {
                let data = res.data.records || [];
                this.setChildFlag(data);
                resolve(data);
              }
            }
          })
          .catch(() => {});
      },
      /**判断是否有子级节点 */
      setChildFlag(data) {
        data.forEach((el) => {
          el.hasChildren = false;
          if (el.hasChild == 1) {
            el.hasChildren = true;
          }
        });
      },
      //表格为树形结构，且节点懒加载时，刷新节点数据
      getLazyLoadList(parentUuid) {
        let listData = this[customData.list] || [];
        let flag = false;
        listData.forEach((el) => {
          if (el.hasChildren) {
            flag = true;
          }
        });
        if (!flag) {
          this.getList();
        } else {
          let data = {
            ...this[customData.query],
            ...{ parentUuid: parentUuid },
          };
          utils.formTrim(data);
          let paginations = {
            pageSize: -1,
            pageNum: 1,
          };
          if (!this.listUrl) {
            this.listUrl = this.moduleUrl ? this.moduleUrl + "/list" : "";
          }
          base
            .list(this.listUrl, Object.assign(data, paginations))
            .then((res) => {
              if (res.code === "00000") {
                if (res.data && res.data.records) {
                  let data = res.data.records || [];
                  //setChildFlag 设置tree-table的hasChildren
                  if (this.setChildFlag) {
                    this.setChildFlag(data);
                  }
                  let tableRef = this.$refs[customData.tableRef].$refs.tableRef;
                  if (tableRef) {
                    this.$set(
                      tableRef.store.states.lazyTreeNodeMap,
                      parentUuid,
                      data
                    );
                  }
                  this.getBtnList();
                }
              }
            })
            .catch(() => {});
        }
      },
      getBtnList() {
        this.btnList = this.$options.data.call(this).btnList;
      },
      // 重置查询条件查询
      resetQueryInfo() {
        this[customData.query] = {};
        this.paginations.pageNum = 1;
        this.initList();
      },
      // 查询列表
      handleQuery() {
        this.paginations.pageNum = 1;
        this.getList();
      },
      // 页码改变事件
      handleSizeChange(val) {
        this.paginations.pageSize = val;
        this.paginations.pageNum = 1;
        this.getList();
      },
      // 跳转页查询列表
      handleCurrentChange(val) {
        this.paginations.pageNum = val;
        this.getList();
      },
      // 列表单击事件
      handleCurrentRowChange(val) {
        this.currentRow = val;
      },
      // 列表多选获取操作id集合
      handleSelectionChange(val) {
        // 融合多页数据并去重
        this.selectList = utils.unique(this.otherList.concat(val), "uuid");
        this.selectUuids = [...this.selectList.map((item) => item.uuid)];
        if (this.selectExtend) this.selectExtend();
      },
      // 全选取消勾选时清除对应选中id
      handleSelectAll(val) {
        this.handleSelectionChange(val);
      },
      // 批量删除
      batchDel(msg, title) {
        if (this.selectUuids.length === 0) {
          base.showMsg("请选择要操作的节点", "error");
          return;
        }
        this.handleDelete("", msg, title);
      },
      // 单个删除
      singleDel(row, msg, title) {
        let uuid = row.uuid;
        this.selectUuids = [uuid];
        this.handleDelete(row, msg, title);
      },
      // 调用删除接口并提示用户确认删除
      handleDelete(row, msg, title) {
        base.showMsgBox(msg, title).then(() => {
          this.delLoading = true;
          let url = this.deleteUrl
            ? this.deleteUrl
            : this.moduleUrl + "/remove";
          let data = {};
          if (customData.delParams) {
            this.$set(data, [customData.delParams], this.selectUuids);
          } else {
            data = this.selectUuids;
          }
          base
            .remove(url, data)
            .then((res) => {
              if (res.code === "00000") {
                utils.isLastData(
                  this.paginations,
                  this[customData.list].length,
                  this.selectUuids.length
                );
                if (!this.refreshExtend) {
                  if (
                    !customData.lazyLoad ||
                    !row.parentUuid ||
                    row.parentUuid == "0"
                  ) {
                    this.getList();
                  } else {
                    this.getLazyLoadList(row.parentUuid);
                  }
                } else {
                  this.refreshExtend(row);
                }
                this.selectUuids = [];
                this.delLoading = false;
                base.showMsg("删除成功", "success");
              } else {
                if (row) {
                  this.selectUuids = [];
                }
                this.delLoading = false;
              }
            })
            .catch(() => {
              if (row) {
                this.selectUuids = [];
              }
              this.delLoading = false;
            });
        });
      },
      // 变更数据状态，传入表格当前列数据及是否三状态字典参数
      handleUpdateStatus(row, params, url) {
        let data = params || {};
        let status = row.status !== 1 ? 1 : data.isMore ? 2 : 0;
        let msg = data.msg ? data.msg : status === 1 ? "启用" : "停用";
        let statusUrl = url
          ? url
          : this.moduleUrl + `/update/${row.uuid}/${status}`;
        base.showMsgBox(data.title || `确定进行${msg}操作？`).then(() => {
          base.updateStatus(statusUrl).then((res) => {
            if (res.code === "00000") {
              if (!this.refreshExtend) {
                if (
                  !customData.lazyLoad ||
                  !row.parentUuid ||
                  row.parentUuid == "0"
                ) {
                  this.getList();
                } else {
                  this.getLazyLoadList(row.parentUuid);
                }
              } else {
                this.refreshExtend(row);
              }

              base.showMsg(msg + "成功", "success");
            }
          });
        });
      },
      formatterList(list) {
        list.forEach((row, index) => {
          row.orderNum =
            (this.paginations.pageNum - 1) * this.paginations.pageSize +
            index +
            1;
          row.descOrderNum =
            this.paginations.total -
            ((this.paginations.pageNum - 1) * this.paginations.pageSize +
              index);
          this.formatterDic(row);
          this.formatterTime(row);
        });
      },
      doLayout() {
        this.$nextTick(() => {
          if (this.$refs[customData.tableRef]) {
            this.$refs[customData.tableRef].doLayout();
          }
        });
      },
      formatterDic(row) {
        if (!this.formatDics) return;
        this.formatDics.forEach((dic) => {
          this.$set(
            row,
            dic.key + "Val",
            utils.getDicName(row[dic.key], this[dic.list])
          );
        });
      },
      formatterTime(row) {
        if (!this.formatTimes) return;
        this.formatTimes.forEach((time) => {
          this.$set(
            row,
            time + "Val",
            utils.formatDatetime(row[time], "yyyy/MM/dd")
          );
        });
      },
      isDataEmpty(res) {
        return res.code === "00000" && res.data;
      },
    },
  };
}

export default new CustomList();
